import { default as React, useEffect, useState } from "react";
import { Text } from "../../../externalComponents/tailwind/text";

export function SendAudioDialogPermissionDenied() {
  const [browser, setBrowser] = useState(null);

  useEffect(() => {
    // Détection simple du navigateur
    const userAgent = navigator.userAgent;

    if (/chrome|chromium|crios/i.test(userAgent)) {
      setBrowser("chrome");
    } else if (/firefox|fxios/i.test(userAgent)) {
      setBrowser("firefox");
    } else if (/edg/i.test(userAgent)) {
      setBrowser("edge");
    } else {
      setBrowser("other");
    }
  }, []);

  return (
    <Text className="text-red-500 font-semibold mt-4 text-left">
      ⚠️ Microphone access was denied. To enable it:
      <br />
      {browser === "chrome" || browser === "edge" ? (
        <>
          1️⃣ Click the <strong>🔒 lock icon</strong> next to the website
          address.
          <br />
          2️⃣ Find <strong>"Microphone"</strong> and select{" "}
          <strong>"Allow"</strong>.
          <br />
          3️⃣ Refresh the page and try recording again.
          <br />
        </>
      ) : null}
      {browser === "firefox" ? (
        <>
          1️⃣ Click the <strong>🔒 lock icon</strong> next to the website
          address.
          <br />
          2️⃣ Go to <strong>"Clear Permissions"</strong>.
          <br />
          3️⃣ Refresh the page and retry.
          <br />
        </>
      ) : null}
      {browser === "other" ? (
        <p>
          The steps to enable microphone permissions may vary depending on your
          browser. Please check your browser settings to enable it.
        </p>
      ) : null}
    </Text>
  );
}
